import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scoreFormat',
  standalone: true,
})
export class ScoreFormatPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (!value) {
      return '-.-';
    }

    if (Number.isInteger(value)) {
      return value.toString();
    }

    return Number.parseFloat(value.toFixed(2)).toString();
  }
}
